import abstractBg from "@repo/assets/img/abstract-bg.webp"
import hkLogo from "@repo/assets/logos/hk-black.png"
import type { ReactNode } from "react"

import { useBranding } from "@/lib/use-branding"

export function AuthLayout({ children }: { children: ReactNode }) {
  const branding = useBranding()
  const logoLight = branding?.logoLight
  const logoDark = branding?.logoDark

  return (
    <div className="grid min-h-svh grid-cols-1 bg-background lg:grid-cols-2">
      <div className="relative hidden overflow-hidden bg-muted lg:block">
        <img
          src={branding?.loginImage?.url ?? abstractBg}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div
          aria-hidden
          className="absolute inset-0 bg-linear-to-t from-black/80 via-black/20 to-transparent"
        />
        <div className="absolute inset-x-0 bottom-0 flex flex-col gap-3 p-10 text-white">
          <p className="font-mono text-xs tracking-widest text-white/70 uppercase">
            Henry Klevor · Dashboard
          </p>
          <p className="max-w-md font-sans text-2xl leading-snug font-semibold">
            Manage your website, bookings, and content from one place.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-10">
        <div className="flex w-full max-w-sm flex-col items-center gap-8">
          <img
            src={logoLight?.url ?? hkLogo}
            alt={logoLight?.alt ?? "Henry Klevor"}
            className={
              logoDark ? "h-12 w-auto dark:hidden" : "h-12 w-auto dark:invert"
            }
          />
          {logoDark && (
            <img
              src={logoDark.url}
              alt={logoDark.alt ?? "Henry Klevor"}
              className="hidden h-12 w-auto dark:block"
            />
          )}
          {children}
          <p className="text-center text-xs text-muted-foreground">
            Private dashboard. Access is limited to the site owner.
          </p>
        </div>
      </div>
    </div>
  )
}
